import { render, staticRenderFns } from "./editAudioChapter.vue?vue&type=template&id=1dbe4c5e&"
import script from "./editAudioChapter.vue?vue&type=script&lang=js&"
export * from "./editAudioChapter.vue?vue&type=script&lang=js&"
import style0 from "./editAudioChapter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports